const TAG_COLORS = [
  "#d11799",
  "#8e24aa",
  "#3949ab",
  "#0277bd",
  "#00796b",
  "#2e7d32",
  "#ef6c00",
  "#c62828",
  "#6d4c41",
  "#546e7a",
];

const MAX_TAGS = 10;
const MAX_TAG_NAME_LENGTH = 40;

const DEFAULT_TAG_SUGGESTIONS = [
  "Essen",
  "Einkauf",
  "Transport",
  "Unterkunft",
  "Freizeit",
];

const normalizeTagName = (name) =>
  String(name ?? "")
    .normalize("NFC")
    .trim()
    .replace(/\s+/g, " ");

// Mirrors utf8mb4_general_ci, which ignores case and accents.
const tagKey = (name) =>
  normalizeTagName(name)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

const isValidTagName = (name) => {
  if (typeof name !== "string") return false;
  const normalized = normalizeTagName(name);
  return normalized.length > 0 && normalized.length <= MAX_TAG_NAME_LENGTH;
};

const uniqueTagNames = (names = []) => {
  const seen = new Set();
  const unique = [];
  for (const name of names) {
    const key = tagKey(name);
    if (key === "" || seen.has(key)) continue;
    seen.add(key);
    unique.push(normalizeTagName(name));
  }
  return unique;
};

const isTagColor = (value) =>
  typeof value === "string" && /^#[0-9a-fA-F]{6}$/.test(value);

const nextTagColor = (usedColors = []) => {
  const counts = new Map(TAG_COLORS.map((color) => [color, 0]));
  for (const color of usedColors) {
    const key = String(color ?? "").toLowerCase();
    if (counts.has(key)) counts.set(key, counts.get(key) + 1);
  }
  return TAG_COLORS.reduce((best, color) =>
    counts.get(color) < counts.get(best) ? color : best,
  );
};

const findTag = (tags = [], name) => {
  const key = tagKey(name);
  return tags.find((tag) => tagKey(tag.name) === key);
};

const tagDuplicateMessage = (name) =>
  `Es gibt bereits einen Tag „${normalizeTagName(name)}“ in der Gruppe.`;

module.exports = {
  TAG_COLORS,
  MAX_TAGS,
  MAX_TAG_NAME_LENGTH,
  DEFAULT_TAG_SUGGESTIONS,
  normalizeTagName,
  tagKey,
  isValidTagName,
  uniqueTagNames,
  isTagColor,
  nextTagColor,
  findTag,
  tagDuplicateMessage,
};
